// A failed API call with its HTTP status (0 when no response arrived) and the message the API
// put in its response envelope, so callers can tell a rejection from an unknown outcome.
export class ApiError extends Error {
  constructor(message: string, readonly status: number, readonly serverMessage: string | null) {
    super(message);
    this.name = 'ApiError';
  }
}
